// ************************************************************************************************
// pathname: /v1/resume/video
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

interface UseSwrResumeVideoDeleteProps {
  locale?: Locale;
  successToastText?: string;
  successCallback?: () => void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: Delete the user's Video CV.
 * The endpoint acts on the currently authenticated user, so it takes no path params.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successToastText - string. The message shown in the success toast.
 * @param successCallback - function. The callback to call on success.
 * @param errorCallback - function. The callback to call on error.
 */
export const useSwrResumeVideoDelete = (props: UseSwrResumeVideoDeleteProps) => {
  const {
    locale = 'ro', successToastText, successCallback, errorCallback,
  } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: '/v1/resume/video',
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => successCallback?.(),
      onError: () => errorCallback?.(),
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText,
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
